import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function TicketExampleModal({ show, onHide, productionType }) {
	let body;
	let title;
	let url;
	switch (productionType) {
		case "standard":
			title = "Standard Ticket Example";
			body = (
				<p>
					This is our base production level. With “standard” production, you get
					a high-quality video with minimal editing. We will take a few of your
					looks and edit them together with a script or recording of your
					choosing. Only Ratava videos can be included in the standard level of
					production. If you are looking to add captions to a short video, this
					is the level for you. Delivery will be in 1080p or 4k, whichever you
					prefer. This is recommended for simple messages, social media posts,
					and single video translations or captions.{" "}
				</p>
			);
			url =
				"https://drive.google.com/file/d/19Dx6-O61SiKtKfFVO5xx1-9zePo3audN/preview";
			break;
		case "pro":
			title = "Pro Ticket Example";
			body = (
				<p>
					This is our mid-tier production level. With “pro” production, our
					editors ramp it up a notch with more cuts, sound effects, transitions,
					music, and some simple graphics. We will add company branding,
					captions, and title cards to “pro” videos if requested. In addition to
					videos generated on the Ratava platform, our editors will include
					other elements such as B-Roll, photos, titles, and any other media
					provided by the client. Delivery can be in any format and aspect
					ratio. This is recommended for pitch videos, complex social media
					posts, marketing campaigns, and website videos.
				</p>
			);
			url =
				"https://drive.google.com/file/d/1D_azhGxsW6_hmCl81uN814kg-R_9BlAO/preview";
			break;
		case "cinematic":
			title = "Cinematic Ticket Example";
			body = (
				<p>
					This is our highest production level. With cinematic production, you
					will have a dedicated team to create whatever you can dream.
					Professional level editings, sound design, colour grading, visual
					effects, and post-production finishing will be applied at the highest
					level. Anything you need, we can make it happen. We will help from the
					writing of the script all the way to the delivery of the final
					product. This is recommended for viral social media videos and
					high-level marketing campaigns.
				</p>
			);
			url =
				"https://drive.google.com/file/d/13j1L0MZStAKf97ek6yXJEaUMW3D9eXVg/preview";
			break;
		default:
			title = "Ticket Example";
	}

	return (
		<Modal
			show={show}
			onHide={onHide}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{/* If url is present, show an iframe */}
				{url && (
					<div
						style={{
							position: "relative",
							width: "100%",
							paddingBottom: "56.25%" /* 16:9 ratio */,
							marginBottom: "1rem",
						}}
					>
						<iframe
							title="Ticket Video"
							src={url}
							allow="encrypted-media"
							allowFullScreen
							style={{
								position: "absolute",
								top: 0,
								left: 0,
								border: "none",
								width: "100%",
								height: "100%",
							}}
						/>
					</div>
				)}
				{body}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onHide}>
					Close
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
